import React from 'react';
import imgImage45 from '../../assets/sections/29416f076756becc156dbc8ae597844d80b2a61e.png';
import imgEUngVienNu31 from '../../assets/sections/236ff267a05f789487c19516d1473e6cf4942e0a.png';
import imgTopcvLogoOnDarkBlue1Vectorized from '../../assets/sections/b6d3d607d69c7aab1ca0ef4d3b848ac99917a1ce.svg';
import imgEllipse2 from '../../assets/sections/3276284cf9cdca7f9bf68c69cb5a1a8e34371596.svg';
import imgVector11 from '../../assets/sections/6aed0cda9b2cf3868af9c7ef11de5d6bcde837d4.svg';


export default function Participants() {
  return (
    <div className="bg-[#012e2a] relative w-[1921px] h-[1080px]" data-node-id="193:111">
      <div className="absolute inset-[26.11%_-18.64%_30.73%_61.58%]" data-name="TOPCV_LOGO_ON-DARK-BLUE 1 [Vectorized]" data-node-id="193:141">
        <img alt="" className="absolute block max-w-none size-full" src={imgTopcvLogoOnDarkBlue1Vectorized} />
      </div>
      <div className="absolute h-[863px] left-[1084px] top-[704px] w-[1097px]" data-node-id="193:178">
        <div className="absolute inset-[-79.26%_-62.35%]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse2} />
        </div>
      </div>
      <div className="absolute content-stretch flex flex-col items-start left-[133px] px-[42px] py-[36px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[352px] w-[855px]" data-node-id="193:159">
        <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[42px] relative shrink-0 text-[#e9fffa] text-[30px] w-full" data-node-id="193:160">
          Sinh viên khối Đại học, Cao đẳng (mọi ngành nghề) có quan tâm đến cơ hội việc làm tại Hải Phòng
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute content-stretch flex flex-col items-start left-[133px] px-[42px] py-[36px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[545px] w-[855px]" data-node-id="193:169">
        <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[42px] relative shrink-0 text-[#e9fffa] text-[30px] w-full" data-node-id="193:170">
          Ứng viên đang tìm kiếm cơ hội mới: Có quan tâm tới thị trường việc làm Hải Phòng
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <div className="absolute content-stretch flex flex-col items-start left-[133px] px-[42px] py-[36px] rounded-[16px] shadow-[0px_60px_104px_0px_rgba(0,0,0,0.05)] top-[738px] w-[855px]" data-node-id="193:172">
        <div aria-hidden="true" className="absolute bg-[#1a433f] inset-0 pointer-events-none rounded-[16px]" />
        <p className="font-['Alexandria',sans-serif] font-normal leading-[42px] relative shrink-0 text-[#e9fffa] text-[30px] w-full" data-node-id="193:173">
          Ứng viên tại Hải Phòng
        </p>
        <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_100px_0px_rgba(0,177,79,0.1)]" />
      </div>
      <p className="absolute font-['Alexandria',sans-serif] font-bold leading-[normal] left-[calc(50%-827.5px)] text-[#e9fffa] text-[70px] top-[219px] uppercase whitespace-nowrap" data-node-id="193:175">
        Đối tượng tham gia
      </p>
      <div className="absolute h-[406px] left-[1036px] top-[388px] w-0" data-node-id="193:177">
        <div className="absolute inset-[-1.23%_-5px]">
          <img alt="" className="block max-w-none size-full" src={imgVector11} />
        </div>
      </div>
      {/* New right-side image from Figma update */}
      <div className="absolute h-[862px] left-[1309px] top-[219px] w-[523px]" data-name="image 45" data-node-id="2003:591">
        <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage45} />
      </div>
      <div className="absolute h-[806px] left-[921px] top-[274px] w-[753px]" data-name="E - Ứng viên - Nữ 3 1" data-node-id="2003:593">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img alt="" className="absolute h-[100.03%] left-[-82.97%] max-w-none top-[-0.02%] w-[267.61%]" src={imgEUngVienNu31} />
        </div>
      </div>
    </div>
  );
}
